const VISITOR_KEY = 'wc_visitor_id';
const SESSION_KEY = 'wc_session_id';

const apiHost = () => process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

function createId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `v_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = createId();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return createId();
  }
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = createId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return createId();
  }
}

function pageTitleFromPath(pathname) {
  if (pathname === '/' || pathname === '/home') return 'หน้าแรก';
  if (pathname.startsWith('/topicdetail/')) return 'รายละเอียดหมวดหมู่';
  if (pathname === '/missionvision') return 'วิสัยทัศน์และพันธกิจ';
  if (pathname === '/contact') return 'ติดต่อเรา';
  if (pathname === '/login') return 'เข้าสู่ระบบ';
  if (pathname.startsWith('/admin')) return 'ระบบจัดการ';
  return document.title || pathname;
}

function extractCategoryId(pathname) {
  const match = pathname.match(/^\/topicdetail\/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

const recentKeys = new Map();

function shouldDedupe(key, windowMs = 1500) {
  const now = Date.now();
  const last = recentKeys.get(key) || 0;
  if (now - last < windowMs) return true;
  recentKeys.set(key, now);
  // เก็บเฉพาะรายการล่าสุด
  if (recentKeys.size > 50) {
    const oldest = recentKeys.keys().next().value;
    recentKeys.delete(oldest);
  }
  return false;
}

/**
 * ส่ง event สถิติ (ไม่บล็อก UX เมื่อล้มเหลว)
 */
export async function trackEvent({
  event_type = 'page_view',
  page_path,
  page_title,
  category_id = null,
  content_id = null,
  document_id = null,
} = {}) {
  try {
    const path = page_path || `${window.location.pathname}${window.location.search}`;
    // ตัด basename /wc ออกให้ path สั้นและคงที่
    const normalizedPath = path.replace(/^\/wc/, '') || '/';

    const dedupeKey = `${event_type}:${normalizedPath}:${content_id || ''}`;
    if (event_type === 'page_view' && shouldDedupe(dedupeKey)) {
      return;
    }

    const payload = {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      event_type,
      page_path: normalizedPath.slice(0, 500),
      page_title: (page_title || pageTitleFromPath(normalizedPath)).slice(0, 500),
      category_id: category_id ?? extractCategoryId(normalizedPath),
      content_id,
      document_id,
      referrer: (document.referrer || '').slice(0, 500) || null,
    };

    // ไม่ใช้ apiService เพื่อไม่ให้ redirect เมื่อ 401 และไม่ spam console
    await fetch(`${apiHost()}/statistics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (error) {
    // silent fail
    if (process.env.NODE_ENV === 'development') {
      console.debug('analytics track skipped:', error.message);
    }
  }
}

export function trackPageView(pathname, title) {
  return trackEvent({
    event_type: 'page_view',
    page_path: pathname,
    page_title: title,
  });
}

export function trackDocumentOpen({ contentId, categoryId, title, documentId = null }) {
  return trackEvent({
    event_type: 'document_open',
    page_path: `/content/${contentId}`,
    page_title: title || `เอกสาร #${contentId}`,
    category_id: categoryId || null,
    content_id: contentId || null,
    document_id: documentId,
  });
}
